// Ficha do candidato: os campos do contato sao salvos como "Grupo|Campo".
// Campos antigos (sem "|") caem em "Outras informações".
export const GRUPOS_FICHA = [
  { id: "Dados pessoais", curto: "Pessoais", emoji: "👤" },
  { id: "Escolaridade", curto: "Escolaridade", emoji: "🎓" },
  { id: "Experiência", curto: "Experiência", emoji: "💼" },
  { id: "Vaga e entrevista", curto: "Vaga", emoji: "📅" },
  { id: "Outras informações", curto: "Outras", emoji: "📝" },
];

const IDS = GRUPOS_FICHA.map(g => g.id);
export const GRUPO_OUTRAS = "Outras informações";

export const separarCampo = (name = "") => {
  const i = String(name).indexOf("|");
  if (i < 0) return { grupo: GRUPO_OUTRAS, campo: String(name) };
  const grupo = name.slice(0, i);
  return { grupo: IDS.includes(grupo) ? grupo : GRUPO_OUTRAS, campo: name.slice(i + 1) };
};

export const juntarCampo = (grupo, campo) => (grupo === GRUPO_OUTRAS && !campo.includes("|") ? campo : `${grupo}|${campo}`);

// Campos que vem de outra parte do sistema e nao aparecem na ficha
const OCULTOS = /simula[cç][oõ]es \(json\)/i;

export const agruparFicha = (extraInfo = []) => {
  const grupos = {};
  IDS.forEach(id => { grupos[id] = []; });
  (extraInfo || []).forEach((info, index) => {
    if (!info || OCULTOS.test(info.name || "")) return;
    const { grupo, campo } = separarCampo(info.name);
    grupos[grupo].push({ ...info, campo, index });
  });
  return grupos;
};
